import { render } from "./FeedbackList.vue?vue&type=template&id=639c389e&scoped=true"
import script from "./FeedbackList.vue?vue&type=script&lang=js"
export * from "./FeedbackList.vue?vue&type=script&lang=js"

import "./FeedbackList.vue?vue&type=style&index=0&id=639c389e&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/alice/alice_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-639c389e"]])

export default __exports__